import { Link } from "react-router-dom";
import clsx from "clsx";
import routes from "../../../utils/routes";
import { ReactComponent as InfoIcon } from "../../../Assets/Icons/info.svg";
import sortCountryList from "../../../utils/sortCountry";

const MobileCountryDropdown = ({ countries = [], pathname }) => {


  const [focusedCountry, nonFocusedCountry] = sortCountryList(countries, routes);

  return (
    <ul className="w-full overflow-y-auto h-full pb-40">
      <li className="border-t border-moon last:border-b font-bold leading-14">
        <span className="flex items-center w-full px-8 md:px-12 py-4 text-chestNut font-ubuntu">
          <InfoIcon />
          <span className="ml-2">FOCUSED COUNTRY*</span>
        </span>
      </li>
      {focusedCountry?.map((nav) => {
        return (
          <li
            className={clsx({
              "border-t border-moon last:border-b font-normal": true,
              "bg-drWhite text-chestNut": pathname.includes(nav?.path),
            })}
          >
            <Link to={nav?.path}>
              <span className=" w-full inline-block px-8 md:px-12 py-4 ">
                {`${nav?.title}*`}
              </span>
            </Link>
          </li>
        );
      })}
      <li className="border-t border-moon last:border-b font-bold leading-14">
        <span className="flex items-center w-full px-8 md:px-12 py-4 text-chestNut font-ubuntu">
          <InfoIcon />
          <span className="ml-2">NON-FOCUSED COUNTRY</span>
        </span>
      </li>
      {nonFocusedCountry?.map((nav) => {
        return (
          <li
            className={clsx({
              "border-t border-moon last:border-b font-normal": true,
              "bg-drWhite text-chestNut": pathname.includes(nav?.path),
            })}
          >
            <Link to={nav?.path}>
              <span className=" w-full inline-block px-8 md:px-12 py-4 ">
                {nav?.title}
              </span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default MobileCountryDropdown;
